// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Montserrat/Montserrat-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Montserrat/Montserrat-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Montserrat/Montserrat-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./PlayfairDisplay/PlayfairDisplay-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./PlayfairDisplay/playfair-display-semi-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./PlayfairDisplay/PlayfairDisplay.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('ttf'),
  }
  
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
  }

  @font-face {
    font-family: 'Playfair Display';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('ttf');
  }

  @font-face {
    font-family: 'Playfair Display';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('ttf');
  }

  @font-face {
    font-family: 'Playfair Display';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('ttf');
  }`, "",{"version":3,"sources":["webpack://./src/vendor/fonts/fonts.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;EACF;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;EACF;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;EACF;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0DAAoE;EACtE;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0DAAwE;EAC1E;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0DAA6D;EAC/D","sourcesContent":["@font-face {\r\n    font-family: 'Montserrat';\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-display: swap;\r\n    src: url(./Montserrat/Montserrat-Light.ttf) format('ttf'),\r\n  }\r\n  \r\n  @font-face {\r\n    font-family: 'Montserrat';\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-display: swap;\r\n    src: url(./Montserrat/Montserrat-Regular.woff) format('woff'),\r\n  }\r\n\r\n  @font-face {\r\n    font-family: 'Montserrat';\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-display: swap;\r\n    src: url(./Montserrat/Montserrat-Bold.woff) format('woff'),\r\n  }\r\n\r\n  @font-face {\r\n    font-family: 'Playfair Display';\r\n    font-style: italic;\r\n    font-weight: 400;\r\n    font-display: swap;\r\n    src: url(./PlayfairDisplay/PlayfairDisplay-Italic.ttf) format('ttf');\r\n  }\r\n\r\n  @font-face {\r\n    font-family: 'Playfair Display';\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-display: swap;\r\n    src: url(./PlayfairDisplay/playfair-display-semi-bold.ttf) format('ttf');\r\n  }\r\n\r\n  @font-face {\r\n    font-family: 'Playfair Display';\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-display: swap;\r\n    src: url(./PlayfairDisplay/PlayfairDisplay.ttf) format('ttf');\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
